var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNlpRulesEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_nlp_rules)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5L3.5 1.8L19 1.8L19 23.2L3.5 23.2L0 24Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4 5.8L3.1 2.3L3.1 22.8L0.4 23.8Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.2L18.6 2.2L18.6 22.8L3.5 22.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.2L18.6 2.2L18.6 5.5L3.5 5.5Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 7.2H16.8V8.1H5.2Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 9.8H13.2V10.7H5.2Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 12.4H15.6V13.3H5.2Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 15H10.8V15.9H5.2Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 17.2L14.4 16L16.2 16.3L17.1 17.4L17.1 19.2L16 20.4L14.2 20.6L13.2 19.5Z",
    fill: "#FCB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 17.6L15.2 17.1L16 17.4L16.4 18.2L16.1 19L15.3 19.5L14.5 19.2L14.2 18.4Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 18L15.5 18.2L15.3 18.7L14.9 18.5L15.1 18Z",
    fill: "#FCB813"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_nlp_rules"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlpRulesEngine);
export default __webpack_public_path__ + "static/media/NLP_Rules_Engine.14592db8ee44ae82544d00b99f5b9702.svg";
export { ForwardRef as ReactComponent };